import { Handle, Position, useStore } from 'reactflow';

const connectionNodeIdSelector = state => state.connectionNodeId;

function GroupNode({ data, id }) {
  const connectionNodeId = useStore(connectionNodeIdSelector);
  const isTarget = connectionNodeId && connectionNodeId !== id;

  return (
    <div
      className="relative rounded-xl shadow-lg border border-[#E5E7EB] backdrop-blur-md"
      style={{
        background: 'rgba(255, 255, 255, 0.75)',
        width: '300px',
        height: '350px',
      }}
    >
      <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
        <div className="font-bold text-[#252525] text-lg text-center px-4">
          {data.name || 'Group'}
        </div>
      </div>

      {/* Output handles */}
      <Handle
        type="source"
        position={Position.Right}
        className="right-[-25px] w-3 h-3 border-2 border-black bg-white top-[5.5rem]"
      />
      <Handle
        type="source"
        position={Position.Right}
        className="right-[-25px] w-3 h-3 border-2 border-black bg-white top-[11.5rem]"
      />
      <Handle
        type="source"
        position={Position.Right}
        className="right-[-25px] w-3 h-3 border-2 border-black bg-white top-[17.5rem]"
      />

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className={`w-3 h-3 left-[-26px] top-[175px] ${
          isTarget
            ? 'border-dashed border-2 border-black bg-white'
            : 'bg-white border-transparent'
        }`}
      />
    </div>
  );
}

export default GroupNode;
